import React, { useEffect } from 'react'
import { Card, Table, Skeleton } from 'antd'
import { formatAmount } from 'utils'
import { useDispatch } from 'react-redux'
import { useAuthSelector } from 'store/authSlice/authReducer'
import { useBillingSelector } from 'store/billingSlice/billingReducer'
import { getMessagingCharges } from 'store/billingSlice/billingActions'

const columns = [
  {
    title: 'Usage Item',
    dataIndex: 'UsageItem',
    className: 'ant-table-row-cell-break-word',
  },
  {
    title: 'Quota',
    dataIndex: 'Quota',
    className: 'ant-table-row-cell-break-word',
  },
  {
    title: 'Current Usage',
    dataIndex: 'CurrentUsage',
    className: 'ant-table-row-cell-break-word',
  },
  {
    title: 'Charges Due',
    dataIndex: 'ChargesDue',
    className: 'ant-table-row-cell-break-word',
    render: (_, { ChargesDue }) => formatAmount(ChargesDue),
  },
]

const MessagingCharges = () => {
  const dispatch = useDispatch()
  const { organization } = useAuthSelector()
  const {
    loading: { fetchingMessagingCharges },
    messagingCharges,
  } = useBillingSelector()

  useEffect(() => {
    if (organization?.id) {
      dispatch(getMessagingCharges(organization?.id))
    }
  }, [dispatch, organization?.id])

  return (
    <Card>
      <Skeleton
        loading={fetchingMessagingCharges}
        active
        paragraph={{ rows: 8 }}
      >
        <Table
          className="t-w-[300px] sm:t-w-full"
          tableLayout="auto"
          scroll={{ x: 'max-content' }}
          columns={columns}
          dataSource={messagingCharges || []}
          bordered={false}
          pagination={false}
        />
      </Skeleton>
    </Card>
  )
}

export { MessagingCharges }
